import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import { isAuthenticated } from '../ProtectedRoute/index'
import { logout } from '../../actions/authAction';
// import { SlackLoginButton } from "react-social-login-buttons";

const Header = () => {
  const dispatch = useDispatch();
  const history = useHistory()
  // const redirectUrl = 'https://fe3d-103-95-83-255.ngrok.io/slack/login'
  // const slackClientId = '3048730068753.3029748902406'
  // const slackUserScope = 'app_mentions:read,bookmarks:read,calls:read,bookmarks:write,calls:write,channels:history,channels:join,chat:write,channels:manage,channels:read,chat:write.customize,chat:write.public,commands,conversations.connect:read,conversations.connect:manage,users:write,conversations.connect:write,emoji:read,files:read,files:write,groups:history,groups:read,groups:write,usergroups:write,im:history,incoming-webhook&user_scope=admin,admin.apps:read,admin.apps:write,admin.analytics:read,admin.conversations:write,admin.barriers:read,admin.conversations:read,admin.legal_holds:read,admin.barriers:write,admin.invites:write,admin.invites:read,admin.users:read,admin.teams:write,admin.teams:read'
  // const slackUserScope = 'admin chat:write'
  const {  error, logoutError } = useSelector(
    (state) => state.auth
  );
  useEffect(() => {
    if (logoutError) {
      alert.error(logoutError);
      //dispatch({ type: LOGOUT_RESET });
    }
  }, [logoutError, error]);
  const handleLogout = () => {
    dispatch(logout(history));
  };
  // const openNewWindow = () => {
  //   // https://slack.com/oauth/v2/authorize?client_id=3048730068753.3029748902406&scope=app_mentions:read,bookmarks:read,calls:read,bookmarks:write,calls:write,channels:history,channels:join,chat:write,channels:manage,channels:read,chat:write.customize,chat:write.public,commands,conversations.connect:read,conversations.connect:manage,users:write,conversations.connect:write,emoji:read,files:read,files:write,groups:history,groups:read,groups:write,usergroups:write,im:history,incoming-webhook&user_scope=admin,admin.apps:read,admin.apps:write,admin.analytics:read,admin.conversations:write,admin.barriers:read,admin.conversations:read,admin.legal_holds:read,admin.barriers:write,admin.invites:write,admin.invites:read,admin.users:read,admin.teams:write,admin.teams:read
  //   let url = `https://slack.com/oauth/v2/authorize?user_scope=${slackUserScope}&client_id=${slackClientId}&redirectUrl=${redirectUrl}`
  //   let left = (window.screen.width/2-200);
  //   let top = (window.screen.height/2-300);
  //   window.open(url, '', 'resizable=yes, width=' + 500 + ', height=' + 650 + ', top=' + top + ', left=' + left, '_blank')
  // }
  return (
    <nav className="navbar navbar-fixed-top">
      <div className="container-fluid">

        <div className="navbar-left">
          <div className="navbar-btn">
            <a href="/#"><img src="https://wrraptheme.com/templates/hexabit/html/assets/images/icon-light.svg" alt="Meta Brief" className="img-fluid logo" /></a>
            <button type="button" className="btn-toggle-offcanvas"><i className="lnr lnr-menu fa fa-bars"></i></button>
          </div>
          {/* <a href="#" className="icon-menu btn-toggle-fullwidth"><i className="fa fa-arrow-left"></i></a> */}
        </div>

        <div className="navbar-right">
          {/* <form id="navbar-search" className="navbar-form search-form">
                      <input className="form-control" placeholder="Search here..." type="text" />
                      <button type="button" className="btn btn-default"><i className="icon-magnifier"></i></button>
                  </form>                 */}

          <div id="navbar-menu">
            {/* <buuton onClick={openNewWindow}><lable>Connect with Slack</lable></button> */}

            <ul className="nav navbar-nav">
              {/* <li>
                <SlackLoginButton
                  onClick={openNewWindow}
                  text="Connect Slack"
                  fontSize="12px"
                  style={{width:"100%", height:"30px", fontSize: '12px', fontWeight: '600', background : "#FFFFFF !important", fontColor : "#000000", borderColor : "#DDDDDD"}}
                />
              </li> */}
              <li><a href="#" className="right_toggle icon-menu" title="Right Menu"><i className="icon-settings"></i></a></li>
              {isAuthenticated() && (
                <li className="nav-item" onClick={() => handleLogout()}>
                  <span className="icon-menu" >
                    <i className="icon-power"></i>
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </nav>

  );
}
export default Header;